import axios from 'axios'
import config from '@/config'
import { store } from '../../store/store'
import { forceLogout } from '../main'

function update_url(url, options) {
  return (options.custom_url ? options.custom_url : config.serverUrl) + url
}
function add_token_header(options) {
  if (!options.headers) options.headers = {}
  options['headers']['AUTHORIZATION'] = store.getters.securityToken
  return options
}
async function defaultResponse(response) {
  let data = response.data
  if (data.responsecode) {
    if (data.responsecode === 200) {
      return true
    } else if (data.responsecode === 400) {
      let message = data.reason ? data.reason : ''
      await forceLogout(message)
      return false
    } else {
      return false
    }
  }
  return true
}

export default {
  async get(url, options = {}, isAuth = true) {
    if (isAuth) options = add_token_header(options)
    try {
      let response = await axios.get(update_url(url, options), options)
      if (response.status == 200) {
        if (defaultResponse(response)) return response
      }
    } catch (error) {
      let message = error.message
      this.$swal.fire({ text: message, type: 'error' })
      throw error
    }
  },
  async post(url, data, options = {}, isAuth = true) {
    if (isAuth) options = add_token_header(options)
    try {
      let response = await axios.post(update_url(url, options), data, options)
      if (response.status == 200) {
        defaultResponse(response)
        return response
      }
    } catch (error) {
      this.$swal.fire({ text: error.message, type: 'error' })
      throw error
    }
  },
  async put(url, data, options = {}, isAuth = true) {
    if (isAuth) options = add_token_header(options)
    try {
      let response = await axios.put(update_url(url, options), data, options)
      if (response.status == 200) {
        defaultResponse(response)
        return response
      }
    } catch (error) {
      this.$swal.fire({ text: error.message, type: 'error' })
      throw error
    }
  },
  async delete(url, data, options = {}, isAuth = true) {
    if (isAuth) options = add_token_header(options)
    try {
      let response = await axios.delete(update_url(url, options), data, options)
      if (response.status == 200) {
        defaultResponse(response)
        return response
      }
    } catch (error) {
      this.$swal.fire({ text: error.message, type: 'error' })
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/api/index.js